export default {
  root: {
    companies: 'ALL',
    brands: 'ALL',
    delegations: 'ALL',
    users: 'ALL',
  },
  owner: {
    companies: 'ALL',
    brands: 'ALL',
    delegations: 'ALL',
    users: 'ALL',
  },
  admin: {
    companies: 'ALL',
    brands: 'ALL',
    delegations: 'ALL',
    users: 'ALL',
  },
  brandManager: {
    companies: 'READ',
    brands: 'READ',
    delegations: 'READ',
    users: 'READ',
  },
  delegationManager: {
    companies: 'READ',
    brands: 'READ',
    delegations: 'READ',
    users: 'READ',
  },
  operator: {
    companies: 'READ',
    brands: 'READ',
    delegations: 'READ',
    users: 'READ',
  },
  comunityManager: {
    companies: 'NONE',
    brands: 'NONE',
    delegations: 'NONE',
    users: 'NONE',
  },
}
